import API from '@/org-app/api';
import { createGetAllAction } from '@/utils/ActionsUtils';

const actions = {
  getMeasurements: createGetAllAction(API.instance.getMeasurements, null, 'messages.failedToGetMeasurements'),
  getMeasurementDetails: createGetAllAction(
    API.instance.getMeasurementDetails,
    null,
    'messages.failedToGetMeasurementDetails',
  ),
  getAttachedMeasurements: createGetAllAction(
    API.instance.getAttachedMeasurements,
    null,
    'messages.failedToGetAttachedMeasurements',
  ),
};

export default actions;
